import * as React from 'react'

function SvgCr(props) {
	return (
		<svg viewBox="0 0 1000 600" width="1em" height="1em" {...props}>
			<linearGradient id="cr_svg__a">
				<stop offset={0} stopColor="#fbd55f" />
				<stop offset={1} stopColor="#cb8e32" />
			</linearGradient>
			<radialGradient
				id="cr_svg__f"
				cx={416.38}
				cy={814.57}
				gradientTransform="matrix(1 0 0 1.0057 0 -4.636)"
				gradientUnits="userSpaceOnUse"
				r={7.422}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__e"
				cx={393.34}
				cy={837.95}
				gradientTransform="matrix(1 0 0 .99109 0 7.468)"
				gradientUnits="userSpaceOnUse"
				r={7.506}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__d"
				cx={416.58}
				cy={860.97}
				gradientTransform="matrix(1 0 0 1.0082 0 -7.063)"
				gradientUnits="userSpaceOnUse"
				r={7.422}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__c"
				cx={439.62}
				cy={837.58}
				gradientTransform="matrix(1 0 0 .98778 0 10.237)"
				gradientUnits="userSpaceOnUse"
				r={7.506}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__b"
				cx={416.51}
				cy={837.65}
				gradientTransform="matrix(1 0 0 .98848 0 9.646)"
				gradientUnits="userSpaceOnUse"
				r={11.146}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__g"
				cx={760.54}
				cy={474.25}
				gradientTransform="matrix(1 0 0 .99305 0 3.294)"
				gradientUnits="userSpaceOnUse"
				r={12.039}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__h"
				cx={731.81}
				cy={474.25}
				gradientTransform="matrix(1 0 0 .99305 0 1.88)"
				gradientUnits="userSpaceOnUse"
				r={12.039}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__i"
				cx={703.46}
				cy={474.25}
				gradientTransform="matrix(1 0 0 .99305 0 3.294)"
				gradientUnits="userSpaceOnUse"
				r={12.039}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__j"
				cx={771.02}
				cy={499.67}
				gradientTransform="matrix(1 0 0 .991 0 4.502)"
				gradientUnits="userSpaceOnUse"
				r={12.039}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__k"
				cx={742.68}
				cy={499.67}
				gradientTransform="matrix(1 0 0 .991 0 4.502)"
				gradientUnits="userSpaceOnUse"
				r={12.039}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__l"
				cx={714.14}
				cy={499.67}
				gradientTransform="matrix(1 0 0 .991 0 4.502)"
				gradientUnits="userSpaceOnUse"
				r={12.039}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__m"
				cx={772.18}
				cy={526.29}
				gradientTransform="matrix(1 0 0 .99305 0 3.655)"
				gradientUnits="userSpaceOnUse"
				r={12.039}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__n"
				cx={745.39}
				cy={525.29}
				gradientTransform="matrix(1 0 0 .99305 0 3.648)"
				gradientUnits="userSpaceOnUse"
				r={12.039}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__o"
				cx={716.86}
				cy={525.29}
				gradientTransform="matrix(1 0 0 .99305 0 3.648)"
				gradientUnits="userSpaceOnUse"
				r={12.039}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__p"
				cx={768.04}
				cy={552.78}
				gradientTransform="matrix(1 0 0 .98916 0 5.991)"
				gradientUnits="userSpaceOnUse"
				r={11.383}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__q"
				cx={741.28}
				cy={552.78}
				gradientTransform="matrix(1 0 0 .99234 0 4.237)"
				gradientUnits="userSpaceOnUse"
				r={11.347}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__r"
				cx={714.26}
				cy={552.78}
				gradientTransform="matrix(1 0 0 .989 0 6.08)"
				gradientUnits="userSpaceOnUse"
				r={11.385}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__s"
				cx={761.91}
				cy={580.39}
				gradientTransform="matrix(1 0 0 .99259 0 4.303)"
				gradientUnits="userSpaceOnUse"
				r={10.886}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__t"
				cx={737.53}
				cy={577.5}
				gradientTransform="matrix(1 0 0 .99205 0 4.59)"
				gradientUnits="userSpaceOnUse"
				r={10.886}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__u"
				cx={711.71}
				cy={576.36}
				gradientTransform="matrix(1 0 0 .99259 0 4.272)"
				gradientUnits="userSpaceOnUse"
				r={10.886}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__v"
				cx={751.9}
				cy={604.02}
				gradientTransform="matrix(1 0 0 .98919 0 6.531)"
				gradientUnits="userSpaceOnUse"
				r={10.462}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__w"
				cx={729.67}
				cy={600.54}
				gradientTransform="matrix(1 0 0 .99915 0 .513)"
				gradientUnits="userSpaceOnUse"
				r={9.95}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__x"
				cx={706.08}
				cy={597.51}
				gradientTransform="matrix(1 0 0 .99726 0 1.636)"
				gradientUnits="userSpaceOnUse"
				r={8.123}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__y"
				cx={741.9}
				cy={625.39}
				gradientTransform="matrix(1 0 0 .99915 0 .535)"
				gradientUnits="userSpaceOnUse"
				r={9.95}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__z"
				cx={720.45}
				cy={618.78}
				gradientTransform="matrix(1 0 0 1.0069 0 -4.273)"
				gradientUnits="userSpaceOnUse"
				r={8.345}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__A"
				cx={700.55}
				cy={614.7}
				gradientTransform="matrix(1 0 0 .99645 0 2.18)"
				gradientUnits="userSpaceOnUse"
				r={7.03}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__B"
				cx={731.65}
				cy={644.12}
				gradientTransform="matrix(1 0 0 .99834 0 1.067)"
				gradientUnits="userSpaceOnUse"
				r={9.333}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__C"
				cx={712.98}
				cy={635.08}
				gradientTransform="matrix(1 0 0 1.00597 0 -3.791)"
				gradientUnits="userSpaceOnUse"
				r={7.792}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__D"
				cx={695.15}
				cy={628.49}
				gradientTransform="matrix(1 0 0 .99767 0 1.462)"
				gradientUnits="userSpaceOnUse"
				r={6.64}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__E"
				cx={718.42}
				cy={660.82}
				gradientTransform="matrix(1 0 0 1.00252 0 -1.666)"
				gradientUnits="userSpaceOnUse"
				r={8.623}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__F"
				cx={702.21}
				cy={650.42}
				gradientTransform="matrix(1 0 0 .999 0 .647)"
				gradientUnits="userSpaceOnUse"
				r={7.301}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__G"
				cx={686.7}
				cy={642.53}
				gradientTransform="matrix(1 0 0 1.0069 0 -4.435)"
				gradientUnits="userSpaceOnUse"
				r={6.091}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__H"
				cx={707.38}
				cy={674.82}
				gradientTransform="matrix(1 0 0 .9913 0 5.871)"
				gradientUnits="userSpaceOnUse"
				r={7.953}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__I"
				cx={693.57}
				cy={664.01}
				gradientTransform="matrix(1 0 0 1.01302 0 -8.648)"
				gradientUnits="userSpaceOnUse"
				r={6.615}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__J"
				cx={680.18}
				cy={655.53}
				gradientTransform="matrix(1 0 0 1.00534 0 -3.497)"
				gradientUnits="userSpaceOnUse"
				r={5.651}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__K"
				cx={694.25}
				cy={686.15}
				gradientTransform="matrix(1 0 0 1.00986 0 -6.764)"
				gradientUnits="userSpaceOnUse"
				r={6.753}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__L"
				cx={682.92}
				cy={676.43}
				gradientTransform="matrix(1 0 0 1.00582 0 -3.938)"
				gradientUnits="userSpaceOnUse"
				r={5.721}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__M"
				cx={671.83}
				cy={668.65}
				gradientTransform="matrix(1 0 0 1.02442 0 -16.33)"
				gradientUnits="userSpaceOnUse"
				r={4.779}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__N"
				cx={682.71}
				cy={696.23}
				gradientTransform="matrix(1 0 0 1.00802 0 -5.585)"
				gradientUnits="userSpaceOnUse"
				r={6.282}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__O"
				cx={673.31}
				cy={686.5}
				gradientTransform="matrix(1 0 0 1.01694 0 -11.63)"
				gradientUnits="userSpaceOnUse"
				r={5.292}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__P"
				cx={663.89}
				cy={678.28}
				gradientTransform="matrix(1 0 0 1.00862 0 -5.844)"
				gradientUnits="userSpaceOnUse"
				r={4.489}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__Q"
				cx={671.6}
				cy={705.18}
				gradientTransform="matrix(1 0 0 1.0059 0 -4.166)"
				gradientUnits="userSpaceOnUse"
				r={6.282}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__R"
				cx={662.2}
				cy={695.65}
				gradientTransform="matrix(1 0 0 1.01055 0 -7.342)"
				gradientUnits="userSpaceOnUse"
				r={5.292}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__S"
				cx={654.58}
				cy={687.37}
				gradientTransform="matrix(1 0 0 1.01672 0 -11.49)"
				gradientUnits="userSpaceOnUse"
				r={4.49}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__T"
				cx={646.03}
				cy={696.48}
				gradientTransform="matrix(1 0 0 1.02355 0 -16.403)"
				gradientUnits="userSpaceOnUse"
				r={4.136}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__U"
				cx={653.02}
				cy={704.68}
				gradientTransform="matrix(1 0 0 1.00552 0 -3.892)"
				gradientUnits="userSpaceOnUse"
				r={4.489}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__V"
				cx={660.59}
				cy={713.14}
				gradientTransform="matrix(1 0 0 1.0171 0 -12.2)"
				gradientUnits="userSpaceOnUse"
				r={4.846}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__W"
				cx={637.01}
				cy={705.72}
				gradientTransform="matrix(1 0 0 1.01093 0 -7.714)"
				gradientUnits="userSpaceOnUse"
				r={3.872}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__X"
				cx={642.62}
				cy={712.94}
				gradientTransform="matrix(1 0 0 1.01384 0 -9.865)"
				gradientUnits="userSpaceOnUse"
				r={4.135}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__Y"
				cx={649.42}
				cy={720.03}
				gradientTransform="matrix(1 0 0 1.0073 0 -5.25)"
				gradientUnits="userSpaceOnUse"
				r={4.405}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__Z"
				cx={628.35}
				cy={711.82}
				gradientTransform="matrix(1 0 0 1.02676 0 -19.049)"
				gradientUnits="userSpaceOnUse"
				r={3.517}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__aa"
				cx={633.37}
				cy={718.62}
				gradientTransform="matrix(1 0 0 1.02113 0 -15.183)"
				gradientUnits="userSpaceOnUse"
				r={3.871}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__ab"
				cx={639.59}
				cy={726.09}
				gradientTransform="matrix(1 0 0 1.03175 0 -23.056)"
				gradientUnits="userSpaceOnUse"
				r={4.048}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__ac"
				cx={621.03}
				cy={717.31}
				gradientTransform="matrix(1 0 0 1.01622 0 -11.635)"
				gradientUnits="userSpaceOnUse"
				r={3.417}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__ad"
				cx={625.6}
				cy={723.58}
				gradientTransform="matrix(1 0 0 1.01891 0 -13.684)"
				gradientUnits="userSpaceOnUse"
				r={3.634}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__ae"
				cx={629.94}
				cy={730.32}
				gradientTransform="matrix(1 0 0 1.0334 0 -24.397)"
				gradientUnits="userSpaceOnUse"
				r={3.904}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__af"
				cx={614.05}
				cy={721.3}
				gradientTransform="matrix(1 0 0 1.00982 0 -7.086)"
				gradientUnits="userSpaceOnUse"
				r={3.053}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__ag"
				cx={617.69}
				cy={727.85}
				gradientTransform="matrix(1 0 0 1.0159 0 -11.57)"
				gradientUnits="userSpaceOnUse"
				r={3.256}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__ah"
				cx={621.24}
				cy={734.22}
				gradientTransform="matrix(1 0 0 1.00532 0 -3.906)"
				gradientUnits="userSpaceOnUse"
				r={3.473}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__ai"
				cx={606.69}
				cy={724.91}
				gradientTransform="matrix(1 0 0 1.0049 0 -3.546)"
				gradientUnits="userSpaceOnUse"
				r={2.946}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__aj"
				cx={609.28}
				cy={730.85}
				gradientTransform="matrix(1 0 0 1.01859 0 -13.586)"
				gradientUnits="userSpaceOnUse"
				r={3.122}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__ak"
				cx={612.94}
				cy={737.49}
				gradientTransform="matrix(1 0 0 1.01562 0 -11.523)"
				gradientUnits="userSpaceOnUse"
				r={3.378}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__al"
				cx={600.03}
				cy={728.91}
				gradientTransform="matrix(1 0 0 1.0265 0 -19.31)"
				gradientUnits="userSpaceOnUse"
				r={2.506}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__am"
				cx={602}
				cy={734.39}
				gradientTransform="matrix(1 0 0 .98882 0 8.212)"
				gradientUnits="userSpaceOnUse"
				r={2.724}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__an"
				cx={604.74}
				cy={740}
				gradientTransform="matrix(1 0 0 1.00265 0 -1.96)"
				gradientUnits="userSpaceOnUse"
				r={2.914}
				xlinkHref="#cr_svg__a"
			/>
			<radialGradient
				id="cr_svg__ao"
				cx={685.79}
				cy={453.08}
				gradientTransform="matrix(1 0 0 .99658 1.768 2.964)"
				gradientUnits="userSpaceOnUse"
				r={8.107}
				xlinkHref="#cr_svg__a"
			/>
			<g strokeWidth={1.2}>
				<path d="M0 0h1000v600H0z" fill="#002b7f" />
				<path d="M0 100h1000v399.996H0z" fill="#fff" />
				<path d="M0 200.004h1000v200.004H0z" fill="#ce1126" />
				<ellipse cx={300.001} cy={300} fill="#fff" rx={75} ry={87.5} />
			</g>
			<g transform="translate(235.939 234.475) scale(.15382)">
				<g stroke="#000" strokeLinecap="round" strokeLinejoin="round">
					<path
						d="M105.36 349.34l11-20.25-26-7.25-8 18zm622.24 0l-11-20.25 26-7.25 8 18z"
						fill="#cea849"
						strokeWidth={3}
					/>
					<path
						d="M409.48 91.438l-40.094 1.157c-25.601 2.418-35.334 12.29-19.437 30.965-41.272 6.469-81.637 15.908-118.94 35.626-10.486-1.74-22.662 4.134-26.156 14.232-2.912 8.158 4.188 16.828 16.812 13.387-8.35 21.987-106.99 19.428-109.5 56.05 7.472-6.368 15.699-11.766 23.906-6.318l-5.656 17.11c-14.363 4.277-24.455 6.644-30.47 22.363-6.212 15.77-15.13 39.832-21.343 51.671-4.08 5.472-5.063 11.284-5.063 14.17 0 6.814 4.869 16.326 16.125 16.326 11.456 0 17.094-7.175 17.094-14.388-.666-5.02-2.644-10.912-14.75-10.228 20.321-4.871 37.886 1.953 49.687 9.477 16.306 12.038 20.387 35.38 10.875 54.58-9.323 18.654-33.013 29.543-68.344 15.764-28.736-11.292-57.644 3.484-67.156 29.151-43.293 117.15 32.408 212.17 118.22 267.58 89.304 57.703 105.21 73.418 129.09 101.62 24.07 28.155 47.37 60.398 82.312 60.398 5.437 0 10.682-1.56 15.344-4.097 21.995 0 23.424 8.208 52.937 8.727v.03c.512 0 1.004-.026 1.5-.03.492.004.962.03 1.47.03v-.03c29.544-.514 30.965-8.727 52.968-8.727 4.662 2.537 9.876 4.097 15.312 4.097 34.943 0 58.243-32.243 82.312-60.398 23.88-28.205 39.821-43.92 129.12-101.62 85.81-55.415 161.51-150.44 118.22-267.58-9.512-25.668-38.45-40.443-67.187-29.15-35.33 13.778-58.989 2.89-68.312-15.765-9.512-19.2-5.431-42.542 10.875-54.58 11.802-7.524 29.335-14.349 49.656-9.477-12.106-.684-14.053 5.209-14.719 10.228 0 7.213 5.638 14.388 17.094 14.388 11.257 0 16.094-9.512 16.094-16.327 0-2.885-.95-8.697-5.031-14.169-6.212-11.839-15.163-35.903-21.375-51.67-6.014-15.72-16.106-18.087-30.47-22.365l-5.624-17.109c8.207-5.448 16.434-.05 23.906 6.318-2.507-36.622-101.18-34.064-109.53-56.05 12.625 3.442 19.756-5.229 16.844-13.387-3.494-10.098-15.67-15.973-26.156-14.232-37.27-19.72-77.67-29.16-118.94-35.63 15.89-18.68 6.16-28.547-19.44-30.964l-40.094-1.157-7-.219-6.969.219z"
						fill="#dca842"
						strokeWidth={3.001}
					/>
					<g fill="none" strokeWidth={3}>
						<path d="M365.36 93.093c38.572.12 30.016 46.144-5 48.25-43.149 5.035-96.201 3.62-125 15.5m-99 61.247c33.314-9.378 69.202-1.792 91-11.75s26.49-42.896 3-47.25" />
						<path d="M349.11 123.59c7.68-1.77 15.889-2.044 19.979-5.77 4.09-3.727 5.313-10.405-4.48-11.23m-142.989 80.5c7.161-12.05 4.837-20.454-4.518-14.67M467.6 93.093c-38.572.12-30.016 46.144 5 48.25 43.149 5.035 96.201 3.62 125 15.5m99 61.247c-33.314-9.378-69.202-1.792-91-11.75s-26.49-42.896-3-47.25" />
						<path d="M483.85 123.59c-7.68-1.77-15.889-2.044-19.979-5.77-4.09-3.727-5.312-10.405 4.48-11.23m142.979 80.5c-7.161-12.05-4.837-20.454 4.518-14.67M219.23 742.45c61.736 43.665 70.667 100.43 134.54 103.15" />
						<path d="M354.55 854.5c-37.662 8.11-62.318-12.363-92.023-56.818-15.15-22.4-54.94-53.9-122.89-96.38-106.78-66.66-138.42-182.91-103.67-246.66 8.543-15.676 30.48-21.857 43.099-18.346 32.811 8.852 87.947 0 88.141-53.159.194-29.917-24.268-64.879-55.912-64.879-19.224 0-29.511 6.38-34.556 13.154" />
						<path d="M349.89 831.9c0-2.918 2.52-5.984 6.212-5.984 3.688 0 6.988 3.264 6.988 7.32 0 8.9-5.05 13.697-15.725 11.57-8.737-1.73-12.619-11.176-8.93-20.67 3.687-9.643 16.111-15.626 29.505-9.643 13.4 6.182 11.843 26.654 7.187 38.275-2.719 6.725-8.156 12.363-14.756 16.022M613.72 742.45c-61.73 43.66-70.66 100.43-134.73 103.15" />
						<path d="M478.41 854.5c37.662 8.11 62.318-12.363 92.018-56.818 14.949-22.401 54.942-53.901 122.89-96.379 106.77-66.659 138.42-182.92 103.67-246.66-8.538-15.676-30.475-21.857-43.094-18.346-32.811 8.852-87.947 0-88.141-53.159-.194-29.917 24.268-64.879 55.911-64.879 19.219 0 29.511 6.38 34.556 13.154" />
						<path d="M495.88 830.52c0-26.456-44.843-34.764-79.205-34.764-34.168 0-79.205 8.308-79.205 34.764" />
						<path d="M483.07 831.9c0-2.918-2.52-5.984-6.212-5.984-3.688 0-6.988 3.264-6.988 7.32 0 8.9 5.05 13.697 15.725 11.57 8.737-1.73 12.619-11.176 8.93-20.67-3.687-9.643-16.111-15.626-29.505-9.643-13.4 6.182-11.843 26.654-7.187 38.275 2.719 6.725 8.156 12.363 14.756 16.022" />
						<path d="M460.16 857.17c-18.056 0-17.474 19.44-43.681 19.44-26.012 0-25.431-19.44-43.487-19.44" />
					</g>
				</g>
				<g stroke="#000" strokeWidth={3}>
					<path
						d="M416.48 828.14c-12.812 0-12.812 19.035 0 19.035s13.006-19.035 0-19.035"
						fill="url(#cr_svg__b)"
					/>
					<path
						d="M439.58 831.66c-7.957 0-7.957 11.828 0 11.828 7.962 0 8.156-11.828 0-11.828"
						fill="url(#cr_svg__c)"
					/>
					<path
						d="M422.5 860.99c0-8.002-11.843-8.002-11.843 0 0 7.952 11.843 7.952 11.843 0"
						fill="url(#cr_svg__d)"
					/>
					<path
						d="M393.38 843.89c7.957 0 7.957-11.878 0-11.878-7.962 0-8.156 11.878 0 11.878"
						fill="url(#cr_svg__e)"
					/>
					<path
						d="M410.46 814.57c0 7.952 11.843 7.952 11.843 0s-11.843-7.952-11.843 0"
						fill="url(#cr_svg__f)"
					/>
				</g>
				<g id="cr_svg__ap" stroke="#000">
					<path
						d="M154.052 272.66c2.176.121 4.391.67 6.438 1.531 3.615 1.523 6.784 4.129 7.906 7.75.007.023.024.04.031.063 31.912 88.55 14.845 126.29-13.5 183.59-40.958 82.506-11.105 205.42 80.375 259.16 44.974 26.295 79.656 35.262 106.22 41.906 13.281 3.322 24.558 6.07 34.094 10.156 9.2 3.94 18.697 11 24.695 19.174-9.19.76-24.19 3.281-31.554 5.445-10.704-13.603-37.624-26.11-65.484-35.588-27.86-9.478-56.925-16.224-72.688-19.344h-.031c-51.284-14.874-99.1-48.249-135.12-90.656-38.135-44.889-57.625-106.35-50.094-167.97 1.687-14.102 7.292-22.719 15.28-27.406 7.99-4.687 18.097-5.486 28.813-4.78 19.477 1.123 38.56-4.195 56-14.939 22.488-13.845 31.704-38.325 31.344-64.906-.36-26.58-10.401-55.133-26.312-76.406-5.686-7.658-7.962-13.4-7.844-17.844.119-4.444 3.002-7.378 6.531-8.406a13.699 13.699 0 012.75-.5 16.09 16.09 0 012.156-.031z"
						fill="#825123"
						strokeWidth={3}
					/>
					<path
						d="M760.57 462.8c15.337 0 15.337 22.911 0 22.911s-15.531-22.911 0-22.911"
						fill="url(#cr_svg__g)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M731.84 461.38c15.337 0 15.337 22.911 0 22.911s-15.531-22.911 0-22.911"
						fill="url(#cr_svg__h)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M703.5 462.8c15.337 0 15.337 22.911 0 22.911s-15.531-22.911 0-22.911"
						fill="url(#cr_svg__i)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M771.06 488.24c15.337 0 15.337 22.862 0 22.862s-15.531-22.862 0-22.862"
						fill="url(#cr_svg__j)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M742.71 488.24c15.337 0 15.337 22.862 0 22.862s-15.531-22.862 0-22.862"
						fill="url(#cr_svg__k)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M714.17 488.24c15.337 0 15.337 22.862 0 22.862s-15.531-22.862 0-22.862"
						fill="url(#cr_svg__l)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M772.22 514.84c15.337 0 15.337 22.911 0 22.911s-15.531-22.911 0-22.911"
						fill="url(#cr_svg__m)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M745.43 513.84c15.337 0 15.337 22.911 0 22.911s-15.531-22.911 0-22.911"
						fill="url(#cr_svg__n)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M716.89 513.84c15.337 0 15.337 22.911 0 22.911s-15.531-22.911 0-22.911"
						fill="url(#cr_svg__o)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M768.14 542.02c14.368 0 14.368 21.52 0 21.52-14.557 0-14.751-21.52 0-21.52"
						fill="url(#cr_svg__p)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M741.35 542.02c14.363 0 14.363 21.52 0 21.52-14.562 0-14.562-21.52 0-21.52"
						fill="url(#cr_svg__q)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M714.37 542.02c14.368 0 14.368 21.52 0 21.52-14.562 0-14.756-21.52 0-21.52"
						fill="url(#cr_svg__r)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M762.43 570.11c13.782.547 12.812 21.172-.97 20.575-13.786-.596-13.01-21.371.97-20.575"
						fill="url(#cr_svg__s)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M738.05 567.22c13.782.596 12.812 21.172-.974 20.575-13.782-.547-13.006-21.122.974-20.575"
						fill="url(#cr_svg__t)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M712.23 566.07c13.787.596 12.817 21.172-.97 20.575-13.781-.596-13.005-21.371.97-20.575"
						fill="url(#cr_svg__u)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M752.61 594.2c13.205.994 11.843 20.575-1.357 19.631-13.2-.795-12.037-20.575 1.357-19.631"
						fill="url(#cr_svg__v)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M730.29 591.12c12.619.745 11.262 19.581-1.163 18.836-12.619-.795-11.456-19.631 1.163-18.836"
						fill="url(#cr_svg__w)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M706.61 589.93c10.094.596 9.12 15.953-.974 15.158-10.094-.596-9.319-15.705.974-15.158"
						fill="url(#cr_svg__x)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M742.52 615.97c12.619.745 11.262 19.581-1.163 18.836-12.619-.795-11.456-19.631 1.163-18.836"
						fill="url(#cr_svg__y)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M720.97 610.9c10.487.795 9.319 16.5-.97 15.755-10.485-.795-9.512-16.5.97-15.755"
						fill="url(#cr_svg__z)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M700.97 608.22c8.737.348 7.763 13.568-.775 12.971-8.737-.398-7.962-13.568.775-12.971"
						fill="url(#cr_svg__A)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M733.59 635.55c11.456 2.535 7.574 19.83-3.881 17.096-11.456-2.535-7.57-19.581 3.881-17.096"
						fill="url(#cr_svg__B)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M714.56 628c9.512 2.137 6.212 16.5-3.106 14.164-9.513-2.137-6.406-16.5 3.106-14.164"
						fill="url(#cr_svg__C)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M696.51 622.58c7.962 1.74 5.243 13.767-2.719 11.828-7.956-1.74-5.238-13.767 2.719-11.828"
						fill="url(#cr_svg__D)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M721.16 653.24c10.099 3.479 4.662 18.836-5.437 15.158-10.094-3.529-4.85-18.836 5.437-15.158"
						fill="url(#cr_svg__E)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M704.47 644.1c8.543 2.932 3.881 15.755-4.468 12.624-8.538-2.883-4.075-15.705 4.468-12.624"
						fill="url(#cr_svg__F)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M688.55 637.34c6.988 2.286 3.3 12.971-3.688 10.437-6.992-2.485-3.3-13.17 3.688-10.437"
						fill="url(#cr_svg__G)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M710.49 668.2c8.93 4.075 2.719 17.444-6.212 13.17-8.931-3.877-2.719-17.246 6.212-13.17"
						fill="url(#cr_svg__H)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M696.12 658.46c7.38 3.33 2.137 14.562-5.045 11.083-7.38-3.28-2.33-14.562 5.045-11.083"
						fill="url(#cr_svg__I)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M682.34 650.91c6.212 2.932 1.744 12.027-4.274 9.294-6.212-2.883-1.938-12.226 4.274-9.294"
						fill="url(#cr_svg__J)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M697.09 680.63c7.38 3.678 1.556 14.91-5.626 11.033-7.38-3.678-1.75-14.91 5.626-11.033"
						fill="url(#cr_svg__K)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M685.25 671.88c6.212 3.081 1.357 12.425-4.662 9.095-6.212-3.081-1.357-12.425 4.662-9.095"
						fill="url(#cr_svg__L)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M673.79 664.87c5.05 2.733.97 10.288-3.881 7.604-5.05-2.535-1.168-10.486 3.881-7.604"
						fill="url(#cr_svg__M)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M685.83 691.46c6.406 4.075 0 13.816-6.212 9.542-6.407-4.075-.194-13.816 6.212-9.542"
						fill="url(#cr_svg__N)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M675.93 682.57c5.238 3.479 0 11.431-5.243 7.952-5.243-3.479 0-11.68 5.243-7.952"
						fill="url(#cr_svg__O)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M666.03 674.96c4.468 2.932 0 9.542-4.27 6.61-4.462-2.882 0-9.492 4.27-6.61"
						fill="url(#cr_svg__P)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M674.73 700.43c6.406 4.274 0 13.767-6.212 9.492-6.407-4.075-.194-13.767 6.212-9.492"
						fill="url(#cr_svg__Q)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M664.83 691.66c5.238 3.529 0 11.48-5.243 7.952-5.243-3.479 0-11.431 5.243-7.952"
						fill="url(#cr_svg__R)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M656.71 684.11c4.463 2.932 0 9.492-4.274 6.61-4.463-2.932 0-9.741 4.274-6.61"
						fill="url(#cr_svg__S)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M647.98 693.4c4.075 2.535 0 8.747-3.886 6.212-4.076-2.683 0-8.896 3.886-6.212"
						fill="url(#cr_svg__T)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M655.16 701.4c4.463 2.883 0 9.492-4.27 6.56-4.467-2.882 0-9.492 4.27-6.56"
						fill="url(#cr_svg__U)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M662.92 709.55c4.85 3.28 0 10.486-4.662 7.157-4.855-3.082 0-10.487 4.662-7.157"
						fill="url(#cr_svg__V)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M638.85 702.94c3.688 2.535 0 7.952-3.688 5.616-3.692-2.535 0-8.15 3.688-5.616"
						fill="url(#cr_svg__W)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M644.57 709.92c4.075 2.733 0 8.747-3.881 6.014-4.08-2.684 0-8.698 3.881-6.014"
						fill="url(#cr_svg__X)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M651.55 716.84c4.274 2.684 0 9.294-4.27 6.411-4.273-2.932 0-9.343 4.27-6.411"
						fill="url(#cr_svg__Y)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M630 709.28c3.3 2.137 0 7.405-3.3 5.07-3.3-2.138 0-7.356 3.3-5.07"
						fill="url(#cr_svg__Z)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M635.21 715.78c3.688 2.535 0 8.15-3.688 5.666-3.687-2.535 0-8.15 3.688-5.666"
						fill="url(#cr_svg__aa)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M641.53 723.19c3.881 2.535 0 8.747-3.881 5.815-3.882-2.535 0-8.747 3.881-5.815"
						fill="url(#cr_svg__ab)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M622.74 714.97c3.106 2.336-.393 7.008-3.499 4.672-2.912-2.336.393-7.008 3.499-4.672"
						fill="url(#cr_svg__ac)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M627.45 721.07c3.3 2.535-.388 7.554-3.688 5.02-3.3-2.485.388-7.555 3.688-5.02"
						fill="url(#cr_svg__ad)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M631.97 727.58c3.494 2.733-.388 8.35-4.075 5.467-3.494-2.733.387-8.35 4.075-5.467"
						fill="url(#cr_svg__ae)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M615.7 719.44c2.525 2.137-.775 6.063-3.3 3.727-2.52-2.335.78-6.013 3.3-3.727"
						fill="url(#cr_svg__af)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M619.58 725.92c2.525 2.286-.97 6.56-3.688 3.877-2.718-2.336.97-6.61 3.688-3.877"
						fill="url(#cr_svg__ag)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M623.18 732.05c2.912 2.733-.97 7.008-3.881 4.274-2.913-2.485.969-6.958 3.881-4.274"
						fill="url(#cr_svg__ah)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M608.34 723.22c2.33 2.137-.97 5.616-3.3 3.479-2.33-2.336.97-5.815 3.3-3.479"
						fill="url(#cr_svg__ai)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M611.02 729c2.525 2.535-.97 6.212-3.494 3.678-2.524-2.336.97-6.213 3.494-3.678"
						fill="url(#cr_svg__aj)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M614.9 735.44c2.719 2.733-1.163 6.809-3.881 4.075-2.719-2.534.974-6.808 3.881-4.075"
						fill="url(#cr_svg__ak)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M601.5 727.58c1.744 1.938-1.168 4.672-2.912 2.733-1.75-1.938.969-4.87 2.912-2.733"
						fill="url(#cr_svg__al)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M603.61 732.94c1.943 2.137-1.163 5.02-3.3 2.883-1.744-2.137 1.168-5.02 3.3-2.883"
						fill="url(#cr_svg__am)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M606.49 738.49c2.132 2.336-1.362 5.417-3.499 3.131-2.132-2.336 1.362-5.666 3.499-3.131"
						fill="url(#cr_svg__an)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
					<path
						d="M687.6 446.92c10.094 0 10.094 15.158 0 15.158s-10.288-15.158 0-15.158"
						fill="url(#cr_svg__ao)"
						transform="matrix(-1 0 0 1 833.412 0)"
					/>
				</g>
				<use
					height={500}
					transform="matrix(-1 0 0 1 832.957 0)"
					width={833.333}
					xlinkHref="#cr_svg__ap"
				/>
				<path
					d="M182.15 433.08c11.262-37.473 16.893-85.632.974-148.3 70.081-45.226 119.39-86.576 233.55-86.576 113.96 0 167.73 31.41 233.55 86.576-15.725 62.671-10.094 110.63.97 148.3h-469.42"
					fill="#89c5e3"
					stroke="#000"
				/>
				<path
					d="M235.5 341.84l-5.22 56.66c-.051.007-.105-.008-.156 0l-20.12-56.16 9.687 59.312c-.072.033-.147.06-.219.094l-22.47-29.65 13.5 35.25-16.5-11.5 10.031 18.812c-.09.129-.192.245-.28.375l-11.75-1.438 7.28 10.22a38.86 38.86 0 00-2.28 13.17c0 .213.06.411.063.624h77.625c.003-.213.062-.41.062-.625 0-4.637-.791-9.095-2.28-13.219l15.29-14.67-19.25 6.72c-.156-.24-.309-.483-.47-.719 2.958-3.633 31.908-39.25 30.72-39.25-1.229 0-36.6 30.34-37.844 31.406l-.188-.156 27.781-61.5-38.438 55.188c-.126-.05-.248-.108-.375-.156l11.32-58.28-20.25 56-5.25-56.5z"
					fill="#fcdd09"
				/>
				<path
					d="M181.82 433.08c-6.212 20.774-13.975 38.467-20.769 53.576-17.668 39.809-21.356 132.4 43.874 197.85 96.873 96.863 170.65 57.85 207.73 110.63h7.57c37.08-52.78 110.85-13.767 207.73-110.63 65.23-65.454 61.735-158.04 43.873-197.85-6.6-14.959-14.562-32.801-20.774-53.576h-469.42"
					fill="#0f47af"
					stroke="#000"
				/>
				<path
					d="M323.62 343.97c-1.122-5.432-13.795-4.388-12.875-13.125-8.429-1.344-6.858-16.406 8.875-15.375 1.657-2.99 20.674-9.835 18.375-.375 9.544-8.316 16.457-.702 11.125 3 3.682 3.687 5.54 12.114-5.75 11.375 4.32 7.685-5.712 7.399-12.375 5.25.164 2.911-.332 5.217-4.125 4.5-2.394 1.618-.582 3.704-.25 5.625zm174.6 5.93c.107-6.855-12.811-4.763-12.33-12.57-7.012-1.075-5.993-15.596 8.5-14.724-.808-4.194 19.513-9.577 17.596-.36 7.079-7.505 14.066-.489 9.78 2.874 3.526 3.53 7.806 9.601-4.632 10.894 5.013 4.86-5.47 7.085-11.851 5.028.157 2.788-1.693 3.746-5.326 3.06-2.292 1.55.818 4.796 1.136 6.636l-2.873-.838zm100.68 23.69c1.202-5.19-10.656-4.731-10.349-10.643-5.387-.814-4.605-11.809 6.53-11.149-.62-3.176 13.868-8.502 12.896-.772 5.439-5.683 11.432.13 8.139 2.675 2.71 2.674 5.998 7.27-3.559 8.249 3.852 3.68-4.203 5.365-9.105 3.807.12 2.11-.55 2.461-3.342 1.942-1.762 1.173 2.128 4.007 2.372 5.4l-3.582.49z"
					fill="#fff"
				/>
				<path
					d="M-308.88 472.49c2.912-15.158 15.337-29.124 16.699-40.952 1.163-10.685 3.3-15.158 9.512-26.39 6.213-11.282 8.733-16.5 10.094-24.303 1.939-10.089 9.513-12.226 13.006-1.938 3.3 10.288 9.9 36.13 13.394 42.145 3.3 6.013 6.8 14.363 6.213 18.438-.582 4.075 4.468 5.616 7.38 8.548 2.913 2.733 3.3 12.226 11.843 20.377 8.538 8.15 18.051 13.965 26.012 18.04 7.182 16.153 12.037 40.605 10.87 68.536h-533.29c-.195-7.356 0-14.562.387-21.52 47.368-12.226 65.036-43.487 85.03-41.35 10.874-15.158 24.074-31.46 33.199-39.81 10.869-9.89 32.225-49.3 37.662-73.405 5.437-23.856 13.394-36.678 19.412-35.336 6.018 1.392 8.543 2.535 15.725 24.104 9.905 29.67 16.699 33.199 24.268 54.52 6.6 18.488 20.387 51.637 41.548 68.933 13.2-9.89 28.343-20.973 33.194-28.726 4.08-6.809 10.293-17.295 17.668-22.315 3.3-9.89 7.569-27.583 11.068-31.857 3.3-3.877 4.657-7.753 5.044-14.562.194-6.809 5.437-21.172 12.62-33.2 7.186-11.827 16.698-15.704 20.967 0 4.076 15.756 13.588 48.756 22.52 69.33 3.687 8.55 10.486 25.397 25.43 43.09l1.614 1.906c.303-.53.607-.926.911-2.304z"
					fill="#509164"
					stroke="#000"
					strokeWidth={0.999}
					transform="matrix(1.00186 0 0 1 867.911 0)"
				/>
				<g fill="#034418">
					<path d="M497.202 528.38c-9.919-9.542-25.673-7.405-33.645-14.959-7.782-7.356-20.23-2.336-47.073-15.904-3.307-1.74-6.613-3.876-9.919-6.411-21.201-17.295-35.008-50.494-41.62-68.933-7.394-21.172-14.395-24.651-24.314-54.57-5.252-15.904-8.17-20.774-11.67-22.514 9.142 9.94 4.282 25.446 11.67 42.145 2.918 6.61-1.946 6.61-3.5 4.473-1.36-2.137-5.835-3.131-7.976-2.932 3.893 3.33 4.476 11.679 8.364 20.377 3.695 8.747-2.917 7.802 5.06 20.228 2.135 3.478 2.917 8.697-.195 10.834-3.306 1.938-5.641-6.014-10.506-3.28 1.364 3.13 7 8.746 10.7 12.026 3.694 3.33.194 5.07-2.724 3.529-3.112-1.59-7.2-3.131-9.336-4.87 0 2.534 3.112 5.417 7.389 9.293 4.476 3.728 1.558 6.411-8.753 6.411 1.558 2.336.976 8.151-3.695 8.946 6.418.398 11.283 12.226 19.255 13.021 7.782.547 8.56 6.014.976 7.356-7.588 1.342-22.954-10.884-30.537-18.836-1.947 2.733-6.03 3.876-8.948 2.336-.194 3.677.971 12.624 4.472 18.438-3.695-1.541-8.554-6.412-13.42-12.425-4.665-5.616-7.777 2.733-3.694 7.753 4.083 5.069 6.807 9.144.194 13.02-6.418 3.678-10.501 2.336-15.365-4.472-6.807 5.665-9.53 6.013-14.784 5.069 0 3.28-5.641 11.083-8.165 16.898-5.642 11.232 250.125 34.541 242.931 7.356" />
					<path d="M681.164 530.1c-67.298-5.864-104.444-31.857-125.454-56.707-14.976-17.494-21.783-34.541-25.478-43.089-8.947-20.575-18.477-53.576-22.56-69.33-1.365-5.218-3.307-8.35-5.642-9.492-3.5-1.74-1.753 4.274.777 7.355 2.723 2.932 2.529 5.666-.971 3.529-3.5-1.939-5.253 1.938-1.947 6.759 3.112 4.671 7.976 10.139 8.947 15.357.976 5.069 1.365 9.492 3.889 12.027 2.335 2.534-6.418 3.13-10.113-2.883-.194 3.877.976 9.493 3.5 8.896 2.336-.397 3.113 1.74-.194 7.604-3.306 5.616-2.917 7.555-1.747 10.09 1.747 3.876 6.224-11.48 8.947-2.734 1.36 4.075 3.695 9.144 5.83 12.425 2.142 3.13 1.948 5.07-1.164 5.07s-5.836-7.804-6.224-1.194c-.194 6.412 4.864 8.549 10.113 8.151 5.058-.199 5.835 1.74 5.058 4.473-.582 2.733 1.554 5.417 4.472 4.87 2.723-.795 7.005 1.74 9.336 8.35 2.335 6.61-1.554 9.492-7.195 4.82-5.642-4.82-13.808-9.094-14.59-12.623-.582-3.082-2.917 1.391-.388 5.665 2.335 4.274 3.695 6.213 6.807 7.952 3.112 1.54-.194 7.952-5.442 3.877-5.06-3.877-7.394-2.933-8.948 1.54-2.53 7.207-10.113 5.467-7.782 9.344 2.335 3.876 1.364 10.089-2.137 11.63-3.699 1.54-7.976-.746-7.588-7.555-.97 1.342-4.665 1.939-7.583 1.144-.388 9.542-3.112 12.822-8.948 10.288-.194 2.137-.388 5.814-3.306 8.548 6.418-.945 7.778 3.479 8.36 6.212.394 2.734 1.365 2.336 5.06 2.734 3.5.198 7.976 4.82 1.363 3.677-6.617-.944-16.924 1.342-22.953-3.081 6.224 5.616 23.924 5.815 31.314 12.97 53.88 22.167 148.797 29.92 186.326 19.632.195-4.473-.388-14.761-.776-18.041" />
					<path d="M603.028 372.77c1.554.745 3.112 2.883 4.472 6.212 3.306 10.288 9.918 36.082 13.424 42.095 3.306 6.014 6.806 14.363 6.224 18.438-.588 4.076 4.471 5.666 7.389 8.549 2.918 2.733 3.306 12.226 11.865 20.377 8.559 8.15 18.09 14.015 26.06 18.09 4.865 10.834 8.56 25.396 10.113 42.493-22.949-1.74-51.733-8.549-66.128-14.96.583-2.136.583-4.82-.194-8.895-.971-4.076-.194-7.207 4.083-11.083 4.282-3.877 2.918-10.487.587-14.164-2.335-3.48-2.14-5.616-.199-7.753 1.753-1.939 1.753-5.467-2.33-9.344-4.282-3.876-1.364-7.952.97-11.43 2.336-3.53 5.836-9.543 3.307-17.296-2.53-7.554-6.418 1.74-9.53-1.143-1.947-1.988-3.112-5.666-.971-8.747 2.136-2.932.777-8.548-1.753-12.822 5.642-1.54-3.888-18.041-5.447-25.048-1.553-7.008 1.753-10.486-1.942-13.22" />
				</g>
				<path
					d="M358.313 435.81c0 3.678-.97 8.946-1.946 10.685 2.335 3.678 5.447 11.232 5.058 13.568 3.112-2.882 9.142-.596 10.502 7.405 1.364 8.15 2.724 15.705 1.947 20.178 2.723 2.336 8.559 6.411 9.53 10.884.97 4.274 3.889 3.678 6.806 3.28 9.142-1.342 8.365 9.692 17.896 8.15 13.419-1.937 5.059 8.748 18.477 8.35 7.778-.397 18.477 1.143 23.925 8.747 6.024-8.15 11.278-5.069 16.725-2.932 5.447 1.938 12.253 1.392 6.224-2.882-6.224-4.473-18.478-5.07-23.925-3.728-5.447 1.392-13.613.398-19.255-4.622-5.447-5.07-14.976-9.343-20.812-9.542-5.836-.199-7.195-.547-11.666-7.157-4.282-6.41-11.283-5.665-14.784-6.013-3.306-.2-5.835-4.473-1.946-8.548 5.641-6.014-2.336-6.81.582-10.487 2.918-3.678 1.365-8.549-6.418-9.145-7.777-.596-4.86-3.082-3.694-8.548 2.723-12.971-14.784-10.834-13.42-17.047m305.562 69.284c.777-7.952-5.253-11.232-6.612-17.295-1.165-6.014-10.7-6.212-13.225-4.423.971 1.74 0 4.82-1.17 6.56-1.165 1.59-1.165 2.535 1.17 3.33 2.525.596 4.666 1.143 4.86 3.28.194 1.938 1.364.199 2.335-2.336.777-2.485 7.584 3.131 8.365 8.15.583 5.07 3.306 8.549 4.083 2.535m-31.314-8.351c1.165 2.932 5.447 7.008 7.777 7.008 2.335 0 5.836 1.74 6.418 4.472.394 2.336 2.335 5.616 4.865 6.014 2.53.398 1.165 2.336-1.947 2.137-3.306-.199-8.36-2.137-8.748-4.473 1.165 4.87-.394 7.008-3.506 3.48-2.917-3.28-4.47-7.953-8.36-8.549 2.918-.547 3.306-1.342 1.942-4.274-1.165-2.883-.194-10.636 1.559-5.815"
					fill="#509164"
				/>
				<path
					d="M-716.69 545.89c6.382-3.131 16.23-1.938 19.904 1.342 1.93-3.678 5.025-6.411 10.828-5.417 4.644-5.07 8.511-7.604 11.22-5.07 2.708-5.02 11.799-6.212 14.894-3.08 3.288-5.07 9.863-7.406 14.309-4.673 5.803-7.604 16.052-10.288 22.241-6.41 5.417-4.076 11.606-3.28 14.314-.597 2.708 2.535 8.511-2.684 10.833 2.137 4.06-.944 11.794-1.143 13.344 3.13.965-2.335 4.446-3.726 6.382-1.937 0-8.946 6.382-15.755 15.28-13.618 4.253-6.412 11.606-9.095 15.087-6.81 3.674-3.677 11.215-1.142 14.502 3.33 7.16-.198 10.64 3.082 14.314 9.493 3.674 6.411 14.314 10.288 21.083 7.405 6.769-2.534 12.958-3.33 15.28-.198 4.06-3.678 8.511-2.734 11.215-.2 4.644 4.076 9.09-3.13 11.8-.397 4.257 4.473 8.124-4.075 15.665.398 7.353 4.473 21.855 11.232 33.075 11.232s20.117-13.767 27.272-4.076c7.155-4.82 17.988-7.156 25.53-3.08 4.45-4.076 14.7-5.418 18.76-1.542 4.06-6.212 11.798-9.94 18.373-7.802 3.674-6.362 18.374-7.356 22.821 1.59 3.679 0 9.477 3.28 9.477 7.356 3.679 0 9.482 2.335 9.482 6.61 4.06-.994 9.085 1.54 9.863 6.41 8.12-.596 14.7 2.734 18.374 9.493 2.708-2.336 1.158-8.35 7.347-9.492 6.19-.994 8.126.944 9.863 3.081 6.769-5.02 16.25-4.423 24.177 2.733 5.803-2.335 11.22-1.341 12.958 1.541 2.516-2.336 6.576-2.882 10.64-2.882.194 13.17-.97 27.533-3.871 42.294h-523.75c-2.709-14.363-3.867-28.726-3.674-41.946"
					fill="#078930"
					stroke="#000"
					strokeWidth={0.999}
					transform="matrix(1.00186 0 0 1 867.911 0)"
				/>
				<path
					d="M416.28 245.04l-5.243 16.898H393.18l14.557 10.486-5.437 16.898 14.174-10.487 14.368 10.487-5.438-16.898 14.363-10.089h-17.663l-5.437-16.898m-67.947 5.223l-2.525 17.494-17.469 2.733 15.92 7.952-2.72 17.444 12.426-12.624 15.725 8.002-8.156-15.755 12.62-12.425-17.47 2.733-8.155-15.755M282.72 267.16l.194 17.693-16.893 5.616 17.087 5.268v17.643l10.094-14.562 16.893 5.268-10.68-14.214 10.293-14.363-16.893 5.666-10.675-14.214M220.4 294.14l3.106 17.494-15.725 8.35 17.663 2.335 2.913 17.444 7.574-15.904 17.469 2.336-12.812-12.425 7.768-15.755-15.725 8.35-12.812-12.226M484.23 250.66l2.525 17.494 17.469 2.733-15.92 7.952 2.72 17.444-12.426-12.624-15.725 8.002 8.15-15.755L458.6 263.48l17.474 2.733 8.155-15.755m66.011 16.702l-.194 17.693 16.888 5.616-17.082 5.268v17.643l-10.094-14.562-16.893 5.268 10.68-14.214-10.293-14.363 16.7 5.666 10.674-14.214m61.934 27.179l-3.106 17.494 15.725 8.35-17.668 2.335-2.908 17.444-7.574-15.904-17.474 2.336 12.817-12.425-7.768-15.755 15.725 8.35 12.812-12.226"
					fill="#fff"
				/>
				<path
					d="M387.186 672.52l1.938-129.86c0-6.212 1.168-7.206 1.362-.398l.388 131.65"
					fill="#865800"
				/>
				<path
					d="M387.186 672.52l1.938-129.86c0-6.212 1.168-7.206 1.362-.398l.388 131.65"
					fill="#704d25"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M390.676 542.46c4.463-3.877 14.75 4.87 21.157 1.193-3.882 12.574-19.412 2.684-21.157 7.355v-8.548"
					fill="#fff"
				/>
				<path
					d="M390.676 542.46c4.463-3.877 14.75 4.87 21.157 1.193-3.882 12.574-19.412 2.684-21.157 7.355v-8.548"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M431.056 672.72l1.938-129.66c0-6.212 1.168-7.405 1.362-.199l.388 131.4"
					fill="#865800"
				/>
				<path
					d="M431.056 672.72l1.938-129.66c0-6.212 1.168-7.405 1.362-.199l.388 131.4"
					fill="#704d25"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M434.746 542.86c4.463-3.877 14.756 4.87 21.162 1.143-4.08 12.624-19.417 2.733-21.162 7.405v-8.548"
					fill="#fff"
				/>
				<path
					d="M434.746 542.86c4.463-3.877 14.756 4.87 21.162 1.143-4.08 12.624-19.417 2.733-21.162 7.405v-8.548"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M472.596 679.93l1.943-129.91c0-6.212 1.163-7.157 1.357-.15l.388 131.4"
					fill="#865800"
				/>
				<path
					d="M472.596 679.93l1.943-129.91c0-6.212 1.163-7.157 1.357-.15l.388 131.4"
					fill="#704d25"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M476.096 550.02c4.468-3.877 14.756 4.87 21.162.994-4.075 12.624-19.412 2.733-21.162 7.355v-8.498"
					fill="#fff"
				/>
				<path
					d="M476.096 550.02c4.468-3.877 14.756 4.87 21.162.994-4.075 12.624-19.412 2.733-21.162 7.355v-8.498.149z"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M487.546 694.84c-4.468 0-10.094-2.087-11.65-5.616-3.3 3.131-17.081 4.87-22.518.199-3.688 3.13-15.143 5.268-20.968 1.54-4.657 4.076-18.443 3.728-25.625-.546-2.912 3.081-11.262 5.417-15.725 5.815-6.406-9.145-23.687-23.706-34.556-29.124-12.231-6.014-36.693-17.693-49.7-23.31-7.573-3.28-14.561-8.945-.193-2.733 15.337 6.61 39.993 16.5 56.687 23.905 23.88 10.487 119.2 8.946 134.92 7.555 8.156-.547 19.025-6.76 26.6-11.431 5.824-3.53 6.018-1.392.387 1.54-6.213 3.28-13.006 5.815-17.862 12.624-6.6 9.145-15.725 13.22-19.22 19.234"
					fill="#704d25"
				/>
				<path
					d="M487.546 694.84c-4.468 0-10.094-2.087-11.65-5.616-3.3 3.131-17.081 4.87-22.518.199-3.688 3.13-15.143 5.268-20.968 1.54-4.657 4.076-18.443 3.728-25.625-.546-2.912 3.081-11.262 5.417-15.725 5.815-6.406-9.145-23.687-23.706-34.556-29.124-12.231-6.014-36.693-17.693-49.7-23.31-7.573-3.28-14.561-8.945-.193-2.733 15.337 6.61 39.993 16.5 56.687 23.905 23.88 10.487 119.2 8.946 134.92 7.555 8.156-.547 19.025-6.76 26.6-11.431 5.824-3.53 6.018-1.392.387 1.54-6.213 3.28-13.006 5.815-17.862 12.624-6.6 9.145-15.725 13.22-19.22 19.234l-.58.348z"
					fill="#704d25"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M496.476 572.18l-30.868-3.33c-5.437 9.145-6.212 20.575-3.3 28.577 9.9-9.343 27.762-4.473 36.693.348-2.912-8.15-7.38-19.184-2.331-25.396"
					fill="#fff"
				/>
				<path
					d="M496.476 572.18l-30.868-3.33c-5.437 9.145-6.212 20.575-3.3 28.577 9.9-9.343 27.762-4.473 36.693.348-2.912-8.15-7.38-19.184-2.331-25.396l-.194-.199z"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M498.806 597.58c-9.12.199-30.863-.348-37.662-.348-7.375 9.493-3.3 23.856-1.55 29.322 8.15-13.02 33.973-6.063 43.873 3.28-5.05-9.542-8.93-17.693-4.463-32.404"
					fill="#fff"
				/>
				<path
					d="M498.806 597.58c-9.12.199-30.863-.348-37.662-.348-7.375 9.493-3.3 23.856-1.55 29.322 8.15-13.02 33.973-6.063 43.873 3.28-5.05-9.542-8.93-17.693-4.463-32.404l-.198.15z"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M503.276 630.23c-8.931-1.59-37.662-3.529-43.487-5.07-4.662 9.692-8.543 22.316-10.482 34.393 13.975-15.357 46.399-4.076 53.193 10.834-6.794-12.822-13.593-32.205.97-40.157"
					fill="#fff"
				/>
				<path
					d="M503.276 630.23c-8.931-1.59-37.662-3.529-43.487-5.07-4.662 9.692-8.543 22.316-10.482 34.393 13.975-15.357 46.399-4.076 53.193 10.834-6.794-12.822-13.593-32.205.97-40.157h-.195z"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M464.836 562.84l-40.773-5.417c-5.82 6.809-10.094 18.836-9.512 32.8 8.543-8.15 39.799-4.87 47.76 6.81-2.718-12.624-6.212-28.527 2.719-34.392"
					fill="#fff"
				/>
				<path
					d="M464.836 562.84l-40.773-5.417c-5.82 6.809-10.094 18.836-9.512 32.8 8.543-8.15 39.799-4.87 47.76 6.81-2.718-12.624-6.212-28.527 2.719-34.392l-.194.198z"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M461.726 598.18l-45.236-6.014c-7.182 9.145-6.794 22.116-5.05 35.932 10.294-8.548 43.875-3.876 51.837 7.555-4.851-16.7-8.931-26.59-1.357-37.473"
					fill="#fff"
				/>
				<path
					d="M461.726 598.18l-45.236-6.014c-7.182 9.145-6.794 22.116-5.05 35.932 10.294-8.548 43.875-3.876 51.837 7.555-4.851-16.7-8.931-26.59-1.357-37.473h-.194z"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M463.086 635.65l-46.011-4.672c-7.182 8.946-12.037 18.09-10.482 31.46 7.181-11.828 37.662-3.28 50.668 9.89-7.763-10.288-8.543-25.048 5.825-36.678"
					fill="#fff"
				/>
				<path
					d="M463.086 635.65l-46.011-4.672c-7.182 8.946-12.037 18.09-10.482 31.46 7.181-11.828 37.662-3.28 50.668 9.89-7.763-10.288-8.543-25.048 5.825-36.678z"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M388.146 562.84c-5.05 3.877-12.812 17.295-13.98 20.973 8.543-3.479 26.599-4.473 37.86 3.877-3.3-6.412-4.467-17.644-1.555-22.316-4.463-1.938-16.306-2.932-22.13-2.335"
					fill="#fff"
				/>
				<path
					d="M388.146 562.84c-5.05 3.877-12.812 17.295-13.98 20.973 8.543-3.479 26.599-4.473 37.86 3.877-3.3-6.412-4.467-17.644-1.555-22.316-4.463-1.938-16.306-2.932-22.13-2.335l-.194-.2z"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M369.316 590.02c11.843-.199 36.106 2.733 46.593 5.616-6.212 9.343-5.437 25.247-2.912 35.137-16.112-15.904-42.711-15.506-58.436-10.834 2.912-7.206 10.094-22.166 14.562-30.118"
					fill="#fff"
				/>
				<path
					d="M369.316 590.02c11.843-.199 36.106 2.733 46.593 5.616-6.212 9.343-5.437 25.247-2.912 35.137-16.112-15.904-42.711-15.506-58.436-10.834 2.912-7.206 10.094-22.166 14.562-30.118l.193.199z"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M416.296 634.31c-11.456.398-40.768-4.672-54.167-11.282-4.657 12.624-6.794 33.597-7.182 41.151 13.006-17.444 44.848-7.753 54.942 10.089-.969-9.493-4.467-32.801 6.407-40.157"
					fill="#fff"
				/>
				<path
					d="M416.296 634.31c-11.456.398-40.768-4.672-54.167-11.282-4.657 12.624-6.794 33.597-7.182 41.151 13.006-17.444 44.848-7.753 54.942 10.089-.969-9.493-4.467-32.801 6.407-40.157v.199z"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M388.146 562.84c-32.23 19.432-56.687 58.645-65.812 85.83 9.125-.199 20.575 2.733 24.656 10.884 9.512-39.063 22.906-75.145 41.156-96.913"
					fill="#fff"
				/>
				<path
					d="M388.146 562.84c-32.23 19.432-56.687 58.645-65.812 85.83 9.125-.199 20.575 2.733 24.656 10.884 9.512-39.063 22.906-75.145 41.156-96.913v.199zm.97-18.84c-26.4 26.589-63.868 74.002-77.461 99.796m184.821-71.616c7.181 34.938 8.93 81.904 6.019 99.199"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M534.686 635.28c-8.185 4.083-23.7-7.338-31.024-2.152v-4.524c7.11-4.966 22.624 6.455 31.024 2.152v4.745"
					fill="#00009e"
				/>
				<path
					d="M534.686 635.28c-8.185 4.083-23.7-7.338-31.024-2.152v-4.524c7.11-4.966 22.624 6.455 31.024 2.152v4.745-.22z"
					fill="#002b7f"
				/>
				<path
					d="M534.686 640.02c-8.185 4.083-23.7-7.338-31.024-2.373v-4.745c7.11-4.966 22.624 6.456 31.024 2.152v4.745"
					fill="#fff"
				/>
				<path
					d="M534.686 640.02c-8.185 4.083-23.7-7.338-31.024-2.373v-4.745c7.11-4.966 22.624 6.456 31.024 2.152v4.745z"
					fill="none"
				/>
				<path
					d="M534.686 644.77c-8.185 4.304-23.7-7.118-31.024-2.152v-4.745c7.11-4.966 22.624 6.456 31.024 2.373v4.524"
					fill="#ff0016"
				/>
				<path
					d="M534.686 644.77c-8.185 4.304-23.7-7.118-31.024-2.152v-4.745c7.11-4.966 22.624 6.456 31.024 2.373v4.524"
					fill="#ce1126"
				/>
				<path
					d="M534.686 649.51c-8.185 4.304-23.7-7.118-31.024-2.152v-4.745c7.11-4.745 22.624 6.456 31.024 2.152z"
					fill="#fff"
				/>
				<path
					d="M534.686 649.51c-8.185 4.304-23.7-7.118-31.024-2.152v-4.745c7.11-4.745 22.624 6.456 31.024 2.152z"
					fill="none"
				/>
				<path
					d="M534.686 654.04c-8.185 4.304-23.7-7.118-31.024-2.152v-4.745c7.11-4.966 22.624 6.456 31.024 2.152v4.524"
					fill="#00009e"
				/>
				<path
					d="M534.686 654.04c-8.185 4.304-23.7-7.118-31.024-2.152v-4.745c7.11-4.966 22.624 6.456 31.024 2.152v4.744z"
					fill="#002b7f"
				/>
				<g strokeWidth={1.832}>
					<path
						d="M404.084 440.136l.688-46.081c0-2.205.414-2.558.483-.142l.137 46.717"
						fill="#865800"
					/>
					<path
						d="M404.084 440.136l.688-46.081c0-2.205.414-2.558.483-.142l.137 46.717"
						fill="#704d25"
						stroke="#000"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={0.65}
					/>
					<path
						d="M405.322 393.984c1.584-1.376 5.235 1.728 7.508.423-1.377 4.462-6.888.952-7.508 2.61v-3.033"
						fill="#fff"
					/>
					<path
						d="M405.322 393.984c1.584-1.376 5.235 1.728 7.508.423-1.377 4.462-6.888.952-7.508 2.61v-3.033"
						fill="none"
						stroke="#000"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={0.65}
					/>
					<path
						d="M419.651 440.207l.688-46.01c0-2.205.415-2.628.483-.071l.138 46.628"
						fill="#865800"
					/>
					<path
						d="M419.651 440.207l.688-46.01c0-2.205.415-2.628.483-.071l.138 46.628"
						fill="#704d25"
						stroke="#000"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={0.65}
					/>
					<path
						d="M420.96 394.126c1.584-1.376 5.237 1.728 7.51.405-1.448 4.48-6.89.97-7.51 2.628v-3.033"
						fill="#fff"
					/>
					<path
						d="M420.96 394.126c1.584-1.376 5.237 1.728 7.51.405-1.448 4.48-6.89.97-7.51 2.628v-3.033"
						fill="none"
						stroke="#000"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={0.65}
					/>
					<path
						d="M434.392 442.765l.69-46.099c0-2.204.412-2.54.481-.053l.138 46.628"
						fill="#865800"
					/>
					<path
						d="M434.392 442.765l.69-46.099c0-2.204.412-2.54.481-.053l.138 46.628"
						fill="#704d25"
						stroke="#000"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={0.65}
					/>
					<path
						d="M435.634 396.666c1.585-1.375 5.236 1.729 7.51.353-1.447 4.48-6.889.97-7.51 2.61v-3.016"
						fill="#fff"
					/>
					<path
						d="M435.634 396.666c1.585-1.375 5.236 1.729 7.51.353-1.447 4.48-6.889.97-7.51 2.61v-3.016.053z"
						fill="none"
						stroke="#000"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={0.65}
					/>
					<path
						d="M439.697 448.056c-1.585 0-3.582-.74-4.134-1.993-1.17 1.112-6.061 1.729-7.99.071-1.31 1.111-5.374 1.87-7.441.547-1.653 1.446-6.545 1.322-9.093-.194-1.034 1.093-3.997 1.922-5.58 2.063-2.274-3.245-8.406-8.412-12.263-10.335-4.34-2.134-13.02-6.278-17.636-8.27-2.687-1.165-5.167-3.175-.069-.97 5.443 2.345 14.192 5.854 20.116 8.482 8.474 3.721 42.299 3.174 47.877 2.68 2.894-.193 6.751-2.398 9.439-4.056 2.067-1.252 2.136-.494.137.547-2.204 1.164-4.615 2.063-6.338 4.48-2.342 3.245-5.58 4.69-6.82 6.825"
						fill="#704d25"
					/>
					<path
						d="M439.697 448.056c-1.585 0-3.582-.74-4.134-1.993-1.17 1.112-6.061 1.729-7.99.071-1.31 1.111-5.374 1.87-7.441.547-1.653 1.446-6.545 1.322-9.093-.194-1.034 1.093-3.997 1.922-5.58 2.063-2.274-3.245-8.406-8.412-12.263-10.335-4.34-2.134-13.02-6.278-17.636-8.27-2.687-1.165-5.167-3.175-.069-.97 5.443 2.345 14.192 5.854 20.116 8.482 8.474 3.721 42.299 3.174 47.877 2.68 2.894-.193 6.751-2.398 9.439-4.056 2.067-1.252 2.136-.494.137.547-2.204 1.164-4.615 2.063-6.338 4.48-2.342 3.245-5.58 4.69-6.82 6.825l-.206.123z"
						fill="#704d25"
						stroke="#000"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={0.65}
					/>
					<path
						d="M442.866 404.53l-10.954-1.182c-1.93 3.245-2.204 7.301-1.17 10.141 3.512-3.316 9.85-1.587 13.02.123-1.034-2.892-2.619-6.807-.827-9.011"
						fill="#fff"
					/>
					<path
						d="M442.866 404.53l-10.954-1.182c-1.93 3.245-2.204 7.301-1.17 10.141 3.512-3.316 9.85-1.587 13.02.123-1.034-2.892-2.619-6.807-.827-9.011l-.069-.071z"
						fill="none"
						stroke="#000"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={0.65}
					/>
					<path
						d="M443.693 413.543c-3.236.07-10.952-.123-13.365-.123-2.617 3.368-1.17 8.465-.55 10.405 2.892-4.62 12.056-2.152 15.569 1.164-1.792-3.386-3.17-6.279-1.584-11.499"
						fill="#fff"
					/>
					<path
						d="M443.693 413.543c-3.236.07-10.952-.123-13.365-.123-2.617 3.368-1.17 8.465-.55 10.405 2.892-4.62 12.056-2.152 15.569 1.164-1.792-3.386-3.17-6.279-1.584-11.499l-.07.053z"
						fill="none"
						stroke="#000"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={0.65}
					/>
					<path
						d="M445.279 425.13c-3.17-.565-13.365-1.253-15.432-1.8-1.654 3.44-3.031 7.919-3.72 12.204 4.96-5.449 16.466-1.446 18.877 3.845-2.411-4.55-4.824-11.428.343-14.25"
						fill="#fff"
					/>
					<path
						d="M445.279 425.13c-3.17-.565-13.365-1.253-15.432-1.8-1.654 3.44-3.031 7.919-3.72 12.204 4.96-5.449 16.466-1.446 18.877 3.845-2.411-4.55-4.824-11.428.343-14.25h-.068z"
						fill="none"
						stroke="#000"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={0.65}
					/>
					<path
						d="M431.638 401.216l-14.468-1.923c-2.065 2.416-3.582 6.684-3.376 11.64 3.032-2.892 14.123-1.729 16.949 2.416-.965-4.48-2.205-10.123.964-12.204"
						fill="#fff"
					/>
					<path
						d="M431.638 401.216l-14.468-1.923c-2.065 2.416-3.582 6.684-3.376 11.64 3.032-2.892 14.123-1.729 16.949 2.416-.965-4.48-2.205-10.123.964-12.204l-.069.07z"
						fill="none"
						stroke="#000"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={0.65}
					/>
					<path
						d="M430.535 413.756l-16.052-2.134c-2.549 3.245-2.411 7.848-1.792 12.75 3.652-3.033 15.569-1.375 18.394 2.681-1.721-5.925-3.17-9.435-.482-13.297"
						fill="#fff"
					/>
					<path
						d="M430.535 413.756l-16.052-2.134c-2.549 3.245-2.411 7.848-1.792 12.75 3.652-3.033 15.569-1.375 18.394 2.681-1.721-5.925-3.17-9.435-.482-13.297h-.068z"
						fill="none"
						stroke="#000"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={0.65}
					/>
					<path
						d="M431.017 427.053l-16.327-1.658c-2.548 3.174-4.271 6.42-3.72 11.163 2.549-4.197 13.365-1.163 17.98 3.51-2.754-3.65-3.031-8.888 2.067-13.015"
						fill="#fff"
					/>
					<path
						d="M431.017 427.053l-16.327-1.658c-2.548 3.174-4.271 6.42-3.72 11.163 2.549-4.197 13.365-1.163 17.98 3.51-2.754-3.65-3.031-8.888 2.067-13.015z"
						fill="none"
						stroke="#000"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={0.65}
					/>
					<path
						d="M404.425 401.216c-1.792 1.375-4.547 6.137-4.961 7.442 3.031-1.235 9.438-1.587 13.435 1.375-1.171-2.275-1.586-6.26-.552-7.918-1.584-.688-5.786-1.04-7.854-.829"
						fill="#fff"
					/>
					<path
						d="M404.425 401.216c-1.792 1.375-4.547 6.137-4.961 7.442 3.031-1.235 9.438-1.587 13.435 1.375-1.171-2.275-1.586-6.26-.552-7.918-1.584-.688-5.786-1.04-7.854-.829l-.068-.07z"
						fill="none"
						stroke="#000"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={0.65}
					/>
					<path
						d="M397.743 410.86c4.202-.07 12.812.97 16.533 1.993-2.204 3.316-1.929 8.96-1.033 12.469-5.718-5.644-15.156-5.502-20.736-3.845 1.033-2.557 3.581-7.865 5.167-10.687"
						fill="#fff"
					/>
					<path
						d="M397.743 410.86c4.202-.07 12.812.97 16.533 1.993-2.204 3.316-1.929 8.96-1.033 12.469-5.718-5.644-15.156-5.502-20.736-3.845 1.033-2.557 3.581-7.865 5.167-10.687l.069.07z"
						fill="none"
						stroke="#000"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={0.65}
					/>
					<path
						d="M414.414 426.577c-4.066.141-14.467-1.658-19.222-4.003-1.652 4.48-2.41 11.922-2.548 14.602 4.615-6.19 15.914-2.751 19.496 3.58-.344-3.368-1.585-11.64 2.274-14.25"
						fill="#fff"
					/>
					<path
						d="M414.414 426.577c-4.066.141-14.467-1.658-19.222-4.003-1.652 4.48-2.41 11.922-2.548 14.602 4.615-6.19 15.914-2.751 19.496 3.58-.344-3.368-1.585-11.64 2.274-14.25v.07z"
						fill="none"
						stroke="#000"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={0.65}
					/>
					<path
						d="M404.425 401.216c-11.437 6.895-20.116 20.81-23.354 30.457 3.238-.07 7.3.97 8.75 3.862 3.375-13.862 8.127-26.666 14.604-34.39"
						fill="#fff"
					/>
					<path
						d="M404.425 401.216c-11.437 6.895-20.116 20.81-23.354 30.457 3.238-.07 7.3.97 8.75 3.862 3.375-13.862 8.127-26.666 14.604-34.39v.07zm.344-6.686c-9.368 9.435-22.664 26.26-27.488 35.413m65.585-25.413c2.548 12.398 3.17 29.064 2.136 35.201"
						strokeWidth={0.65}
						fill="none"
						stroke="#000"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M456.425 426.921c-2.905 1.45-8.41-2.604-11.01-.763v-1.606c2.524-1.762 8.03 2.29 11.01.764V427"
						fill="#00009e"
					/>
					<path
						d="M456.425 426.921c-2.905 1.45-8.41-2.604-11.01-.763v-1.606c2.524-1.762 8.03 2.29 11.01.764V427v-.079z"
						fill="#002b7f"
					/>
					<path
						d="M456.425 428.603c-2.905 1.45-8.41-2.604-11.01-.842v-1.684c2.524-1.762 8.03 2.291 11.01.764v1.684"
						fill="#fff"
					/>
					<path
						d="M456.425 428.603c-2.905 1.45-8.41-2.604-11.01-.842v-1.684c2.524-1.762 8.03 2.291 11.01.764v1.684z"
						fill="none"
					/>
					<path
						d="M456.425 430.289c-2.905 1.527-8.41-2.526-11.01-.764v-1.684c2.524-1.762 8.03 2.291 11.01.842v1.606"
						fill="#ff0016"
					/>
					<path
						d="M456.425 430.289c-2.905 1.527-8.41-2.526-11.01-.764v-1.684c2.524-1.762 8.03 2.291 11.01.842v1.606"
						fill="#ce1126"
					/>
					<path
						d="M456.425 431.97c-2.905 1.528-8.41-2.525-11.01-.763v-1.684c2.524-1.684 8.03 2.291 11.01.764z"
						fill="#fff"
					/>
					<path
						d="M456.425 431.97c-2.905 1.528-8.41-2.525-11.01-.763v-1.684c2.524-1.684 8.03 2.291 11.01.764z"
						fill="none"
					/>
					<path
						d="M456.425 433.578c-2.905 1.528-8.41-2.525-11.01-.763v-1.684c2.524-1.762 8.03 2.29 11.01.763v1.606"
						fill="#00009e"
					/>
					<path
						d="M456.425 433.578c-2.905 1.528-8.41-2.525-11.01-.763v-1.684c2.524-1.762 8.03 2.29 11.01.763v1.684z"
						fill="#002b7f"
					/>
				</g>
				<path
					d="M650.12 284.78c-24.656 97.46 2.912 159.19 21.937 201.88 17.862 39.809 21.356 132.4-43.874 197.85-96.873 96.863-170.65 57.85-207.73 110.63m-7.953.19c-37.08-52.78-110.85-13.76-207.73-110.63-65.23-65.45-61.73-158.04-43.87-197.85 19.02-42.49 46.59-104.22 21.94-201.88"
					fill="none"
					stroke="#000"
					strokeWidth={3}
				/>
				<g stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth={3}>
					<path
						d="M427.55 39.787c1.357 6.308 3.106 23.321-6.212 25.758 17.082 21.075 41.737 24.086 85.03 24.086 27.18 0 49.118-.191 65.23 0 0 5.4-1.75 11.183-1.75 17.921 0 6.5 6.799 9.51 16.7 7.264 9.9-2.246 31.061-8.602 42.512 1.481 19.224 17.204 54.555 20.167 64.067 31.015-2.912-13.094-15.337-26.332-29.119-37.37 13.006-1.864 29.894-.526 35.72 3.918-14.76-15.999-41.55-16.382-55.14-24.219-13.59-7.838-26.6-14.767-36.69-17.395 0-4.444-.587-8.028-4.469-10.609-8.543-5.974-25.237-8.028-38.825-8.793 1.939-2.055 2.326-4.492 2.326-8.22V23.55c0-7.312.78-9.175-7.57-14.385-32.224-19.785-71.441-33.978-142.88-33.978-71.248 0-110.47 14.002-142.88 33.978-8.542 5.21-7.568 7.073-7.568 14.385v21.075c0 3.728.194 6.165 2.326 8.22-13.588.573-30.088 2.628-38.825 8.793-3.688 2.58-4.468 5.974-4.468 10.61-9.9 2.437-22.906 9.366-36.688 17.394-13.593 7.838-40.38 8.22-55.136 24.23 5.63-4.445 22.519-5.974 35.525-3.92-13.588 10.849-26.012 24.087-29.12 37.372 9.513-10.849 44.844-13.812 64.262-31.016 11.257-10.084 32.419-3.918 42.513-1.481 9.9 2.246 16.699-.573 16.699-7.264 0-6.738-1.75-12.521-1.75-17.921 15.92-.382 37.856 0 65.23 0 43.1 0 67.755-3.01 85.03-24.086-9.512-2.437-7.763-19.259-6.212-25.758-20.188-4.492-30.282-12.138-46.593-12.138-16.112 0-19.025 8.554-19.025 11.756v2.628c-12.812 0-30.868-3.202-35.331-11.613 24.85-10.084 61.736-19.21 112.4-19.21 50.668 0 87.555 9.127 112.4 19.21-4.463 8.411-22.52 11.613-35.331 11.613v-2.628c0-3.01-2.719-11.756-19.025-11.756s-26.405 7.455-46.593 12.138h-.775z"
						fill="#89c5e3"
					/>
					<g fill="none">
						<path d="M260.98 89.965c-12.619.191-21.55.956-26.405 2.437-7.763 2.438-8.538 6.547-3.494 8.793M339.21 42.176v9.749c0 6.308 6.794 14.528 17.28 14.528 25.819 0 30.868-4.444 50.087-3.919" />
						<path d="M406.38 62.009c-17.86-3.011-32.03-12.521-47.76-12.521-15.531 0-18.831 7.073-16.112 10.466M224.48 72.809V92.02c0 5.257 3.688 12.521 17.668 9.749 12.231-2.246 20.188.526 20.188 5.782" />
						<path d="M267.96 53.215c2.912 2.963 9.319 5.591 23.493 10.657 26.012 9.51 85.805 16.009 124.64-.956M528.88 30.42c5.05 2.055 9.706 4.11 13.787 6.165 24.263 12.138 26.012 14.958 17.469 19.594m11.654 33.786c12.619.191 21.55.956 26.405 2.437 7.763 2.438 8.538 6.547 3.494 8.793M493.36 42.176v9.749c0 6.308-6.794 14.528-17.28 14.528-25.819 0-30.868-4.444-50.087-3.919" />
						<path d="M426.18 62.009c17.87-3.011 32.04-12.521 47.77-12.521 15.526 0 18.831 7.073 15.919 10.466M608.09 72.809V92.02c0 5.257-3.688 12.521-17.668 9.749-12.231-2.246-20.193.526-20.193 5.782" />
						<path d="M564.61 53.215c-2.912 2.963-9.319 5.591-23.493 10.657-26.012 9.51-85.805 16.009-124.64-.956" />
					</g>
					<path
						d="M416.28 66.453c11.843 0 12.231-8.937 12.231-17.156 0-8.029-.388-17.013-12.231-17.013s-12.231 8.984-12.231 17.013.388 17.156 12.231 17.156z"
						fill="#89c5e3"
					/>
					<path
						d="M304.55 30.437c-5.169 2.052-9.936 4.105-14.113 6.157-24.843 12.123-26.628 14.939-17.883 19.568"
						fill="none"
					/>
				</g>
				<g id="cr_svg__aq" fill="#078930" stroke="#000" strokeWidth={3}>
					<path d="M387.94 192.56c16.306-10.486 36.499-28.13 43.874-39.809 10.094-16.301 11.456-8.35 19.219-9.691-18.25 19.979-40.962 41.35-57.074 52.63l-6.019-3.13m-136.48 39.21c-40.768-23.11-56.299.994-65.812 2.137 11.257 2.734 20.769 20.774 65.812-2.137z" />
					<path d="M269.71 218.4c-38.83-26.241-56.105-3.33-65.816-2.733 11.068 3.479 19.224 22.315 65.816 2.733z" />
					<path d="M297.47 202.84c-38.248-26.987-56.105-4.473-65.816-4.075 11.068 3.876 18.637 22.514 65.816 4.075z" />
					<path d="M320.38 189.08c-35.137-31.062-55.33-10.486-64.842-11.282 10.482 5.07 16.112 24.452 64.842 11.282z" />
					<path d="M349.69 178.99c-33.582-32.851-54.744-13.22-64.256-14.562 10.288 5.417 14.95 25.396 64.256 14.562z" />
					<path d="M380.37 175.66c-27.762-37.672-51.831-21.917-61.15-24.651 9.125 7.206 10.482 27.384 61.15 24.651z" />
					<path d="M385.42 177.2c-1.362-8.498-17.28-19.383-18.637-23.458 4.075-.398 4.657-5.268 2.912-7.008-1.361-1.342-4.661-.596-6.406 1.193-1.75 2.137-3.494 7.157 2.132 11.431 5.825 4.274 13.205 12.027 15.536 17.842" />
					<path
						d="M214.38 234.5c11.063-3.33 25.043-1.74 34.75-2.733M232.44 218.2c11.451-2.535 25.043 0 34.943 0m-7.183-16.35c11.451-2.087 25.043.596 34.943.596M283.49 184.01c11.65-.944 24.85 3.33 34.556 4.473M313 171.98c11.644-.398 24.656 4.473 34.362 6.212m-1.942-15.162c11.649 1.193 23.686 8.548 32.811 11.48"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</g>
				<use
					height="100%"
					transform="matrix(-1 0 0 1 832.76 0)"
					width="100%"
					xlinkHref="#cr_svg__aq"
				/>
				<g stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth={3}>
					<g fill="#fff">
						<path d="M416.49 190.46c9.125 0 16.888 0 22.519-.745v-13.021c0-4.275 15.143-9.344 38.05-4.871 89.692 17.494 101.92 58.049 170.07 81.357.775.199 3.3.994 6.212 1.54 1.75-4.075 3.688-8.15 5.825-13.17 1.163-3.727 11.068-3.528 19.8.547 10.1 4.87 14.562 10.487 12.817 13.42-1.75 4.274-3.499 7.753-5.05 11.231 15.92 5.666 44.844 14.214 35.332 52.433-7.376-7.156-25.237-14.959-36.3-14.959-12.62 0-26.211-4.82-21.937-18.637-2.331-1.143-6.411-3.28-8.544-3.677-.387 1.193-.969 2.336-1.555 3.479-2.913 7.206-15.531 9.74-28.15 5.467-71.055-24.253-92.992-77.878-176.86-78.624v2.335c0 6.76-8.737 12.971-32.225 12.971-23.3 0-32.225-6.212-32.225-12.97v-2.336c-83.673.546-105.81 54.172-176.86 78.624-12.425 4.274-25.043 1.54-28.15-5.467-.393-1.143-.974-2.287-1.556-3.48-2.137.398-6.212 2.535-8.543 3.678 4.08 13.618-9.125 18.637-21.937 18.637-11.063 0-28.731 7.803-36.3 14.96-9.513-38.02 19.025-46.569 35.33-52.434-1.555-3.478-3.105-6.957-5.049-11.232-1.55-2.932 2.719-8.548 12.812-13.419 8.738-4.274 18.443-4.472 19.805-.546 2.138 4.82 3.882 8.896 5.825 13.17 2.913-.547 5.238-1.342 6.213-1.541 67.949-23.309 80.373-63.863 170.06-81.357 22.717-4.473 38.055.596 38.055 4.87v13.022c5.63.546 13.394.745 22.519.745z" />
						<path d="M393.78 189.71c-6.019-.596-9.512-1.938-9.512-4.274 0-5.815 9.512-3.877 9.512-8.747M165.27 253.58c3.494 8.35 7.962 19.035 12.037 28.13m-20.577-23.86c3.494 8.15 10.099 22.116 12.037 27.931" />
					</g>
					<path
						d="M140.62 255.71c2.33 4.075 14.562-1.938 16.112 1.938 1.362 4.076-2.326 6.213-10.869 9.294m27.567-25.392c1.744 5.218-10.487 7.356-7.962 12.027 1.556 3.081 8.35 2.137 13.786.944"
						fill="none"
					/>
					<path
						d="M384.06 185.24v26.987m55.14-22.517c5.825-.596 9.512-1.938 9.512-4.274 0-5.815-9.512-3.877-9.512-8.747m228.5 76.891c-3.494 8.35-7.962 19.035-12.037 28.13m20.577-23.86c-3.499 8.15-10.099 22.116-12.037 27.931"
						fill="#fff"
					/>
					<path
						d="M692.36 255.71c-2.33 4.075-14.562-1.938-16.112 1.938-1.362 4.076 2.326 6.213 10.869 9.294M659.55 241.55c-1.744 5.218 10.487 7.356 7.962 12.027-1.556 3.081-8.35 2.137-13.787.944"
						fill="none"
					/>
					<path d="M448.91 185.24v26.987" fill="#fff" />
				</g>
				<path d="M203.96 281.77l-7.523-26.884 9.371-2.622c2.396-.67 4.176-.908 5.338-.713 1.162.196 2.24.797 3.233 1.805.994 1.007 1.724 2.342 2.189 4.005.588 2.102.558 3.937-.092 5.503-.649 1.566-1.857 2.774-3.623 3.624 1.146.417 2.144.946 2.995 1.584.85.639 2.108 1.859 3.773 3.66l4.145 4.496-5.3 1.483-4.865-4.947c-1.753-1.79-2.912-2.892-3.476-3.308-.565-.415-1.107-.659-1.629-.73-.52-.072-1.295.035-2.322.323l-.917.256 3.141 11.223zm.097-16.756l3.3-.924c2.018-.564 3.277-1.012 3.777-1.343.5-.331.847-.814 1.039-1.448.192-.633.163-1.396-.087-2.289-.24-.856-.603-1.495-1.09-1.92a2.718 2.718 0 00-1.695-.682c-.453-.018-1.676.251-3.669.81l-3.484.974zm24.613 9.536l-12.392-25.016 15.221-7.54 2.096 4.232-11.092 5.494 2.748 5.546 10.306-5.105 2.088 4.215-10.307 5.105 3.373 6.809 11.467-5.68 2.088 4.214zm20.14-10.63l-15.128-23.463 6.242-4.024c2.326-1.5 3.919-2.368 4.778-2.605 1.376-.373 2.816-.207 4.321.5 1.505.705 2.86 1.992 4.064 3.86 1.094 1.696 1.69 3.324 1.79 4.884.099 1.56-.182 2.881-.843 3.964-.661 1.084-2.165 2.382-4.513 3.896l-2.545 1.64 5.707 8.85zm-8.695-21.991l4.292 6.658 2.145-1.383c1.44-.928 2.354-1.66 2.74-2.197.388-.537.576-1.175.566-1.917-.01-.741-.262-1.496-.757-2.264-.502-.78-1.096-1.325-1.782-1.639-.685-.313-1.337-.399-1.955-.257-.619.142-1.74.736-3.36 1.781zm10.435-12.159l3.778-2.64 8.66 12.396c1.345 1.925 2.268 3.146 2.769 3.664.871.893 1.815 1.395 2.83 1.507 1.015.111 2.037-.193 3.068-.913.874-.61 1.45-1.304 1.73-2.08.278-.775.277-1.58-.004-2.413-.28-.834-1.217-2.39-2.81-4.67l-8.844-12.66 3.793-2.65 8.398 12.02c2.145 3.07 3.532 5.404 4.16 7.001.628 1.598.664 3.222.106 4.874-.557 1.652-1.777 3.135-3.661 4.451-1.957 1.367-3.73 2.083-5.318 2.148-1.589.065-3.075-.368-4.46-1.297s-3.274-3.106-5.666-6.53zm19.27-13.94l7.703-4.957c2.103-1.353 3.705-2.112 4.806-2.278 1.102-.165 2.259.049 3.471.643 1.212.593 2.214 1.504 3.004 2.732.728 1.131 1.135 2.315 1.22 3.55s-.13 2.33-.65 3.284c1.404-.33 2.744-.211 4.022.355 1.278.567 2.37 1.555 3.278 2.964 1.099 1.708 1.617 3.416 1.554 5.125s-.565 3.063-1.508 4.061c-.655.694-2.403 1.955-5.243 3.782l-6.55 4.215zm6.39 1.413l3.493 5.43 2.562-1.65c1.538-.989 2.47-1.627 2.8-1.914.593-.533.93-1.146 1.012-1.84.081-.695-.129-1.431-.63-2.21-.447-.695-.961-1.16-1.544-1.396-.582-.237-1.124-.27-1.625-.098-.501.172-1.777.917-3.826 2.236zm6.008 9.337l4.04 6.277 3.602-2.319c1.58-1.017 2.541-1.752 2.883-2.206.342-.454.51-1.022.5-1.703-.007-.682-.252-1.396-.733-2.144-.495-.768-1.065-1.296-1.71-1.583a2.97 2.97 0 00-1.956-.19c-.66.16-1.822.776-3.488 1.848zm20.582.56l-12.79-24.557 4.087-2.129 10.617 20.386 10.201-5.313 2.173 4.172zm17.29-9.33l-10.795-25.746 4.25-1.782 10.795 25.746zm18.42-16.67l4.784.377c.226 3.192-.232 5.712-1.376 7.558s-2.853 3.11-5.127 3.79c-2.859.855-5.505.448-7.94-1.222-2.803-1.93-4.851-5.055-6.143-9.372-1.365-4.561-1.405-8.439-.121-11.632 1.118-2.773 3.185-4.611 6.202-5.514 2.456-.735 4.763-.51 6.92.673 1.536.839 2.929 2.35 4.178 4.534l-3.996 2.587c-.713-1.364-1.601-2.307-2.666-2.83a4.377 4.377 0 00-3.293-.277c-1.617.484-2.726 1.584-3.325 3.3-.6 1.717-.414 4.2.558 7.447 1.008 3.369 2.224 5.616 3.647 6.74s2.931 1.449 4.525.972c1.167-.35 2.041-1.105 2.621-2.265.58-1.161.764-2.783.552-4.866zm30.13 3.41l-4.942.924-3.13-5.866-8.986 1.68-.687 6.58-4.83.903 3.63-29.079 4.81-.9zm-10.397-9.292l-4.993-9.606-1.147 10.753zm39.057-1.318l8.208.624c2.076.157 3.624.508 4.645 1.051 1.02.544 1.934 1.399 2.74 2.566.806 1.167 1.396 2.646 1.769 4.439.373 1.793.46 3.992.263 6.598-.179 2.348-.6 4.369-1.262 6.064-.663 1.695-1.44 3.018-2.333 3.97a7.852 7.852 0 01-3.13 2.063c-1.193.425-2.698.569-4.514.43l-8.45-.641zm4.135 4.936l-1.367 17.992 3.373.256c1.445.11 2.502.053 3.171-.17a3.8 3.8 0 001.687-1.11c.456-.519.865-1.36 1.227-2.526.361-1.165.616-2.717.763-4.656.153-2.014.135-3.612-.055-4.794-.19-1.182-.553-2.13-1.089-2.84a4.14 4.14 0 00-2.04-1.479c-.618-.208-1.828-.381-3.632-.518zm19.335 23.604l-1.723-27.188 16.542-1.049.291 4.6-12.054.764.382 6.027 11.201-.71.29 4.58-11.2.71.469 7.4 12.462-.79.29 4.58zm50.4-26.02l4.378 1.965c-.86 3.082-2.14 5.3-3.838 6.654s-3.732 1.969-6.103 1.845c-2.98-.156-5.335-1.43-7.065-3.822-1.992-2.761-2.87-6.392-2.634-10.893.25-4.754 1.516-8.42 3.799-10.995 1.986-2.235 4.55-3.27 7.695-3.106 2.56.134 4.658 1.121 6.29 2.961 1.165 1.307 1.968 3.199 2.41 5.676l-4.633 1.092c-.213-1.524-.732-2.711-1.558-3.562-.827-.85-1.83-1.307-3.008-1.368-1.687-.089-3.1.575-4.243 1.99-1.142 1.414-1.801 3.814-1.978 7.2-.184 3.511.205 6.036 1.166 7.574.962 1.537 2.274 2.35 3.935 2.437 1.217.063 2.294-.354 3.23-1.252.937-.898 1.656-2.363 2.157-4.397zm10.29-2.53c.794-3.23 1.926-5.772 3.396-7.627 1.47-1.854 3.1-3.104 4.893-3.748 1.793-.644 3.786-.696 5.98-.156 3.181.782 5.474 2.634 6.88 5.555 1.406 2.922 1.557 6.626.453 11.113-1.116 4.537-3.048 7.82-5.796 9.85-2.416 1.799-5.22 2.305-8.414 1.52-3.217-.792-5.482-2.532-6.795-5.221-1.493-3.074-1.692-6.836-.597-11.286zm4.668.952c-.767 3.12-.75 5.604.05 7.455.8 1.85 2.074 2.99 3.825 3.421 1.763.434 3.414.02 4.953-1.242s2.704-3.496 3.492-6.701c.773-3.144.781-5.606.023-7.388-.758-1.781-2.05-2.897-3.874-3.345-1.824-.45-3.496-.056-5.016 1.178s-2.67 3.442-3.453 6.622zm19.442 10.388l4.363 1.272c-.926 3.483-.092 5.774 2.502 6.875 1.286.546 2.44.639 3.46.28 1.022-.36 1.744-1.037 2.165-2.03.248-.584.33-1.136.247-1.654-.084-.518-.333-1.02-.747-1.506s-1.5-1.468-3.26-2.945c-1.578-1.318-2.652-2.477-3.22-3.477-.569-1-.88-2.128-.932-3.385s.176-2.487.687-3.69c.595-1.403 1.449-2.53 2.562-3.382 1.113-.851 2.352-1.325 3.717-1.422s2.871.205 4.519.904c2.477 1.052 4.126 2.545 4.947 4.479.82 1.934.74 4.169-.24 6.704l-4.355-1.58c.398-1.458.404-2.593.017-3.405-.386-.812-1.152-1.461-2.297-1.947-1.145-.486-2.13-.621-2.952-.405-.823.216-1.385.68-1.688 1.394-.297.701-.267 1.41.09 2.127.358.718 1.426 1.791 3.205 3.222 1.876 1.527 3.145 2.835 3.807 3.922.662 1.088 1.015 2.28 1.06 3.574s-.263 2.712-.917 4.255c-.947 2.232-2.43 3.816-4.448 4.753s-4.488.785-7.41-.455c-5.165-2.192-6.792-6.352-4.882-12.478zm21.51 20.02l11.3-20.255-5.937-3.312 2.301-4.124 15.882 8.86-2.3 4.124-5.921-3.303-11.3 20.255zm29.75 18.53l-4.205-2.756 1.805-6.4-7.645-5.01-5.053 4.27-4.109-2.694 22.758-18.462 4.093 2.683zm-1.064-13.904l3.051-10.386-8.275 6.962zm10.274 20.564l15.933-22.924 7.99 5.554c2.044 1.42 3.36 2.64 3.95 3.66.589 1.02.812 2.235.669 3.643-.144 1.407-.708 2.82-1.694 4.238-1.246 1.793-2.68 2.938-4.3 3.434-1.621.497-3.322.336-5.102-.484.407 1.149.636 2.255.686 3.317.05 1.063-.09 2.81-.419 5.24l-.825 6.06-4.519-3.141.715-6.901c.263-2.492.375-4.088.336-4.788-.04-.7-.198-1.273-.474-1.72-.277-.448-.853-.976-1.728-1.584l-.782-.544-6.652 9.57zm12.979-10.599l2.815 1.956c1.72 1.196 2.867 1.881 3.441 2.056.574.175 1.167.134 1.777-.121.611-.256 1.18-.765 1.71-1.526.507-.73.769-1.417.785-2.063a2.718 2.718 0 00-.553-1.741c-.275-.361-1.262-1.132-2.96-2.313l-2.972-2.065zm5.891 23.619l15.362-23.31 3.848 2.536-15.362 23.31zm25.3 3.49l3.024 3.726c-2.156 2.364-4.298 3.768-6.424 4.213-2.126.444-4.219.076-6.28-1.102-2.59-1.482-4.118-3.68-4.586-6.595-.535-3.362.317-6.999 2.555-10.91 2.363-4.133 5.144-6.835 8.343-8.106 2.78-1.101 5.536-.87 8.27.693 2.225 1.273 3.653 3.099 4.282 5.477.45 1.691.316 3.742-.404 6.153l-4.63-1.112c.497-1.457.568-2.75.213-3.882a4.374 4.374 0 00-2.069-2.577c-1.466-.838-3.027-.883-4.684-.134-1.656.749-3.326 2.595-5.01 5.537-1.745 3.053-2.535 5.482-2.369 7.288s.971 3.122 2.415 3.948c1.058.605 2.207.718 3.448.338 1.241-.38 2.543-1.365 3.906-2.955zm21.63 20.25l-4.709-1.762.35-6.64-8.561-3.203-3.988 5.279-4.602-1.722 18.13-23.024 4.584 1.715zm-4.102-13.327l.687-10.804-6.537 8.615zm-320.37-250.43l-3.876 1.752-3.752-4.192-7.048 3.185.757 5.547-3.789 1.712-2.856-24.632 3.773-1.706zm-10.412-5.55l-6.033-6.892 1.217 9.07zm12.357 4.955L301.914.455l5.555-1.833 8.383 14.203-1.742-16.393 5.57-1.837 7.4 22.433-3.444 1.136L317.812.505l2.167 18.866-3.58 1.18-9.452-16.462 5.825 17.658zm21.567-6.83l-5.652-22.936 13.955-3.439.956 3.88-10.17 2.506 1.253 5.085 9.45-2.329.952 3.865-9.45 2.328 1.539 6.243 10.513-2.591.952 3.864zm17.554-4.207l-4.196-23.247 8.103-1.462c2.072-.374 3.59-.432 4.553-.175.963.257 1.823.85 2.58 1.777.757.928 1.265 2.11 1.525 3.548.328 1.819.156 3.361-.516 4.629-.671 1.267-1.785 2.189-3.34 2.764.931.443 1.73.968 2.396 1.573.666.606 1.628 1.734 2.887 3.385l3.133 4.117-4.582.827-3.704-4.555c-1.335-1.647-2.223-2.669-2.665-3.064-.443-.395-.88-.643-1.314-.745-.433-.102-1.094-.073-1.981.088l-.793.143 1.751 9.704zm1.416-14.108l2.854-.515c1.744-.315 2.84-.592 3.288-.831.448-.24.778-.618.99-1.137.213-.518.249-1.163.11-1.935-.134-.74-.39-1.308-.766-1.704a2.3 2.3 0 00-1.373-.71c-.38-.051-1.432.079-3.155.39l-3.013.543zm17.71 10.869l-3.202-23.403 3.864-.53 3.202 23.405zm19.11-10.906l3.909 1.099c-.336 2.686-1.13 4.702-2.383 6.047s-2.878 2.114-4.878 2.305c-2.512.241-4.642-.531-6.389-2.317-2.01-2.063-3.198-4.992-3.562-8.788-.385-4.01.218-7.235 1.808-9.675 1.383-2.118 3.4-3.305 6.052-3.559 2.16-.207 4.038.358 5.634 1.694 1.138.948 2.046 2.431 2.725 4.449l-3.742 1.492c-.368-1.25-.95-2.178-1.748-2.787a3.702 3.702 0 00-2.688-.77c-1.422.136-2.523.868-3.302 2.194-.78 1.327-1.032 3.418-.758 6.273.284 2.962.924 5.026 1.92 6.193s2.196 1.684 3.597 1.55c1.027-.099 1.876-.582 2.548-1.45.672-.87 1.091-2.185 1.256-3.95zm25.38 7.385l-4.25.17-1.905-5.294-7.728.309-1.38 5.425-4.154.166 6.593-23.905 4.137-.165zm-7.57-9.05l-3.006-8.653-2.274 8.863zm29.878.829l3.735 1.594c-.68 2.621-1.727 4.518-3.142 5.69-1.416 1.172-3.127 1.724-5.135 1.656-2.523-.085-4.535-1.125-6.037-3.121-1.728-2.305-2.528-5.363-2.4-9.174.136-4.026 1.15-7.147 3.041-9.362 1.645-1.922 3.799-2.838 6.461-2.748 2.169.073 3.958.875 5.368 2.406 1.006 1.087 1.716 2.675 2.13 4.763l-3.904.997c-.204-1.286-.662-2.282-1.374-2.989a3.702 3.702 0 00-2.567-1.11c-1.427-.048-2.613.535-3.557 1.75-.944 1.215-1.464 3.256-1.56 6.122-.101 2.974.268 5.104 1.106 6.39.838 1.286 1.96 1.952 3.366 2 1.03.035 1.936-.335 2.714-1.11.779-.774 1.364-2.025 1.755-3.753zm6.837 9.04l2.042-23.533 14.32 1.242-.346 3.981-10.434-.905-.453 5.217 9.696.841-.344 3.965-9.696-.84-.556 6.404 10.788.936-.344 3.965zm18.007 1.647l3.343-23.384 3.764.538 5.616 16.738 2.232-15.617 3.605.515-3.342 23.385-3.893-.556-5.54-16.353-2.18 15.248zm23.541 3.759l3.863-19.242-5.64-1.132.787-3.918 15.087 3.029-.787 3.918-5.624-1.13-3.863 19.243zm11.97 2.468l6.036-22.838 7.96 2.104c2.036.538 3.436 1.128 4.2 1.769.764.64 1.292 1.541 1.586 2.702.293 1.16.253 2.447-.12 3.86-.473 1.786-1.281 3.111-2.426 3.975-1.145.864-2.544 1.228-4.197 1.091.657.796 1.158 1.609 1.505 2.44.348.83.742 2.26 1.184 4.287l1.097 5.057-4.502-1.19-1.429-5.694c-.513-2.058-.893-3.36-1.128-3.904-.226-.545-.522-.956-.87-1.231-.348-.276-.966-.53-1.834-.76l-.78-.206-2.519 9.534zm7.253-12.182l2.804.74c1.714.454 2.824.666 3.331.64.508-.028.967-.231 1.379-.611.411-.38.717-.95.917-1.708.193-.727.202-1.35.027-1.868a2.3 2.3 0 00-.943-1.224c-.323-.207-1.33-.535-3.023-.982l-2.96-.783zm28.111 22.96l-4.023-1.382.143-5.625-7.315-2.512-3.252 4.557-3.932-1.35 14.806-19.892 3.916 1.345zm-3.776-11.18l.333-9.153-5.332 7.437zm5.769 12.051l9.405-21.458 3.572 1.565-7.808 17.813 8.914 3.907-1.598 3.645z" />
			</g>
		</svg>
	)
}

export default SvgCr
